import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { callThunk, sendEpsilonOrderNumber } from '~/api';
import { ROUTES } from '~/constants/routes';
import { GMOASK_STATUS } from '~/constants/api';
import { SURVEY_STATUSES } from '~/constants';

/**
 * Epsilon結果判定用
 * JSXは存在しないが、リダイレクトURLでルーター経由で来る為、
 * コンポーネントとして配置
 *
 * NOTE Docs
 * 処理の流れ: https://docs.google.com/spreadsheets/d/1mV8hKvcv6tWiLtTo1iab_woTIRc-NZhazwt3YTwnIrc/edit?pli=1#gid=1887289650
 * イプシロン仕様書: https://drive.google.com/file/d/1Vgo75hSDnaKy5g8h95Pd3yHVdFsTp-Mw/view
 *
 * イプシロンからの戻り値
 * EX: trans_code=1&user_id=11&result=1or2&order_number=0c1028f02876ae4b768a778990070e98
 */
function EpsilonResult() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const EPSILON_STATUS = {
    SUCCESS: 1,
    FAILURE: 0,
  };

  useEffect(() => {
    (async () => {
      const epsilonStatus = Number(searchParams.get('result'));
      // Epsilonからの返却値が成功
      if (epsilonStatus === EPSILON_STATUS.SUCCESS) {
        // API クレカ仮決済完了API
        const res = await dispatch(
          callThunk({
            action: sendEpsilonOrderNumber,
            payload: { orderNumber: searchParams.get('order_number') },
          })
        );

        // 成功
        if (res.payload.status === GMOASK_STATUS.OK) {
          // 初回と再申請でnavigate先を変更
          if (res.payload.result.previousSurveyStatusId === SURVEY_STATUSES.REJECTED) {
            navigate(
              ROUTES.USER.SURVEY_REAPPLY_COMPLETED.replace(':id', res.payload.result.surveyId)
            );
          } else {
            navigate(
              ROUTES.USER.SURVEY_APPLY_COMPLETED.replace(':id', res.payload.result.surveyId)
            );
          }
        } else {
          // エラー画面へ
          navigate(ROUTES.USER[500]);
        }
      } else {
        // Epsilonからの返却値が失敗 エラー画面へ
        navigate(ROUTES.USER[500]);
      }
    })();
  }, []);

  return null;
}

export default EpsilonResult;
